import { useEffect, useState } from "react";
import { ConstVariables } from "./ConstantVariables";
import { HbrAvatarProfile2, HbrBulletinIcon, HbrPlayButton } from "../newComponents/Mycustomsvgicons";
import { DisplayUserPicAndName, FormatTimePassedUtc } from "../newComponents/GeneralClasses";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import db from "../firebase";

const NotificationContent = ({title, body, imageUrl, postID, otherID, user_email, timestamp, docID, closeNotification, getBookReveiewData}) => {
    const [isValidImage, setIsValidImage]=useState(false);
    const [isNotificationPressed, setIsPressed] = useState(false);
    const [showPlayBtn, setShowPlayBtn]=useState(false);
    const [userPic, setUserPic]=useState("");
    // const [state,dispatch] = useReducer(reducer,{progressIndicator: false, showReviewSheet: false});
    const navigate = useNavigate();

    useEffect(()=>{
        const isPressed = Cookies.get(docID);
        isPressed ? setIsPressed(true) : setIsPressed(false);
        if ((title === ConstVariables.SHORT_VIDEOS && imageUrl !== ConstVariables.DUMMI_IMAGE) 
            || (title === ConstVariables.BLOG_WITH_VIDEO && imageUrl !== ConstVariables.DUMMI_IMAGE)) {
            setShowPlayBtn(true);
        }else{
            setShowPlayBtn(false);
        }
    },[docID, title, imageUrl]);

   
    const handleClicked=()=>{
        setIsPressed(true);
        Cookies.set(docID, title);
        if (title === ConstVariables.CHAT_ROOM_TITLE) {
            navigate("/chatRoom");
            // closeNotification();

        }else if (title === ConstVariables.REVIEWS_TITLE) {
            const docRef = doc(db, "book reviews", postID);
            getDoc(docRef).then((snapshot)=>{
                if (snapshot.exists()) {
                    // setBookReviewData(snapshot.data());
                    getBookReveiewData(snapshot.data());
                }
            }).catch(()=>{
               
            });
           
        }else if (title === ConstVariables.DIVINE_BLOGS_TITLE || title === ConstVariables.BLOG_WITH_VIDEO) {
            navigate(`/divineblog/${postID}`);
            // closeNotification();
        }else if (title === ConstVariables.SHORT_VIDEOS) {
            navigate(`/divineshorts/${postID}`);
            // closeNotification();
        }else if (title === ConstVariables.ALL_BOOKS) {
            navigate(`/hbrbooks?language=english&booktitle=${postID}&bookid=/${otherID}`);
            // closeNotification();
        }else if (title === ConstVariables.AUDIO_BOOKS) {
            navigate(`/hrmwaudiobook/${postID}/${otherID}`);
            // closeNotification();
        }else if (title === ConstVariables.BIBLE_QUIZ) {
            navigate("/hbrbiblequiz");
            // closeNotification();
        }
        closeNotification();
    };

    useEffect(()=>{
        async function getUserInfo() {
            const userInfo = await DisplayUserPicAndName(user_email);
            if (userInfo) {
                setUserPic(userInfo.profilePic);
            };
        }
        getUserInfo();
    },[user_email]);

    useEffect(()=>{
        if (imageUrl !== ConstVariables.DUMMI_IMAGE) {
            setIsValidImage(true);
        }else{
            setIsValidImage(false);
        }
    },[imageUrl]);

    return ( 
    <div className={`notificationcontent flex-column2 ${isNotificationPressed ? 'read':'unread'}`} style={{width:"100%", cursor:"pointer", caretColor:"transparent"}} 
    onClick={()=>handleClicked()}>

        <div className="flex-spacearound" style={{width:"100%", gap: "10px"}}>
            {userPic !== "" ? 
                <img src={userPic}alt="" style={{width:"3em", height:"3em", borderRadius:"50%", objectFit:"cover"}} />
                :
                <HbrAvatarProfile2 width={"3em"} height={"3em"}/>
            }
              <p style={{fontWeight: `${!isNotificationPressed ? 'bold' : '100'}`}}>{body}</p>
        </div>

        <div style={{position:"relative"}}>
            {isValidImage && <img src={imageUrl}alt="" style={{maxWidth:"100%", height:"250px", borderRadius:"10px",objectFit:"contain"}} />}
            
            {showPlayBtn && 
                <div style={{borderRadius:"50%", backgroundColor:"#00000050", padding:"10px", position:"absolute", top:"30%", right:"45%"}}>
                    <HbrPlayButton width={"2em"} height={"2em"} fillColour={"white"}/>
                </div>
            }
        </div>
        <div className="flex-row2" style={{gap:"10px"}}>
            <p>{FormatTimePassedUtc(timestamp)}</p>
            {!isNotificationPressed && <HbrBulletinIcon width={"1.3em"} height={"1.3em"} fillColour={"#008080"}/>}
        </div>
     
    </div> 
    );
}
export default NotificationContent;